import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AndroidUIChip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import WDLTheme from 'LegacyWeployDesignLanguage/Theme';

const styles = () => ({
  chip: {
    margin: '0.25em',
    backgroundColor: WDLTheme.colors.weployLightGrey,
    padding: '0 12px',
  },
  label: {
    paddingRight: '0',
    paddingLeft: '0',
    maxWidth: '100%',
  },
});

class Chip extends Component {
  render() {
    const {
      classes,
      children,
      onDelete,
      className,
    } = this.props;
    const classNames = [classes.chip, className].join(' ');

    return (
      <AndroidUIChip
        classes={{ label: classes.label }}
        label={children}
        className={classNames}
        onDelete={onDelete}
      />
    );
  }
}

Chip.propTypes = {
  onDelete: PropTypes.func,
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  className: PropTypes.string,
};

Chip.defaultProps = {
  onDelete: null,
  className: '',
};

export default withStyles(styles)(Chip);
